<template>
  <div class="user-info-component">
    <div class="user-info">
      <ym-avatar class="user-avatar"
                 :avatar="user.avatar"
                 :name="user.name"
                 :lazy="false"
      />
      <div class="info">
        <span class="user-name">{{ user.name }}</span>
        {{ user.age | formatUserAgeAndArea(user.area, ' | ') }}
      </div>
    </div>
    <ym-img class="work-cover"
            :src="cover"
            alt="作品封面"
    />
  </div>
</template>

<script>
  import Avatar from '@/components/Avatar';

  export default {
    name: 'WorkUserInfoComponent',
    components: {
      'ym-avatar': Avatar,
    },
    props: {
      user: {
        type: Object,
        default() {
          return {};
        },
      },
      cover: {
        type: String,
        require: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .user-info-component {
    background: @color-white;
    padding: @size-base;
    display: flex;
    align-content: center;
    justify-content: space-between;
    position: relative;
    &:after {
      position: absolute;
      content: '';
      width: 690px;
      height: 1px;
      background: @background-color-base;
      left: @size-base;
      bottom: 0;
    }
  }

  .user-info {
    display: flex;
    align-items: center;
  }

  .info {
    margin-left: @size-small;
    display: flex;
    flex-direction: column;
    font-size: @font-size-extra-small;
    color: @color-text-lighter;
    .user-name {
      font-weight: @font-weight-primary;
      font-size: @font-size-medium;
      color: @color-text-base;
    }
  }

  .work-cover {
    width: 180px;
    height: 144px;
    border-radius: @border-radius-base;
  }

</style>
